import { renderApp } from './bootstrap/render-app'
import type { Layout, StaticCrumb } from './bootstrap/typings.ts'
import { env } from './env.ts'
import { createAppRouter } from './lib/router'
import { routeTree } from './routeTree.gen'
import './styles.css'
// Create application router
const router = createAppRouter(routeTree)

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}

	interface StaticDataRouteOption {
		layout?: Layout
		breadcrumb?: StaticCrumb
	}
}

if (import.meta.env.DEV) {
	// Dynamically load dev-only diagnostics to keep production bundle lean
	const { logDevDiagnostics } = await import('./lib/dev-diagnostics')
	logDevDiagnostics(env, routeTree)
}

// Mount application
renderApp(document.getElementById('app'), router)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.info)
